import React from 'react';
import styled from 'styled-components';

interface PaginationProps {
  page: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  page,
  totalPages,
  onPrevious,
  onNext
}) => {
  if (totalPages <= 1) return null;

  return (
    <Bar>
      <PaginationButton onClick={onPrevious} disabled={page === 1}>
        ← Previous
      </PaginationButton>
      <Info>
        Page {page} of {totalPages}
      </Info>
      <PaginationButton onClick={onNext} disabled={page === totalPages}>
        Next →
      </PaginationButton>
    </Bar>
  );
};

const Bar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-top: 20px;
  padding: 12px 0;
`;

const PaginationButton = styled.button`
  background: var(--white);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: 6px 14px;
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 500;
  color: var(--ink);
  cursor: pointer;
  transition: all 0.15s;

  &:hover:not(:disabled) {
    border-color: var(--ink);
    background: var(--paper);
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

const Info = styled.span`
  font-size: 12.5px;
  color: var(--ink-muted);
`;
